import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const CanDeleteBoardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanDeleteBoard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}},{"kind":"Argument","name":{"kind":"Name","value":"waitOn"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CurrentBoardFull"}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}},{"kind":"Field","name":{"kind":"Name","value":"idOrganization"}},{"kind":"Field","name":{"kind":"Name","value":"members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"admins"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"prefs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"permissionLevel"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"CanDeleteBoard","document":CanDeleteBoardDocument}} as const;
export type CanDeleteBoardQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type CanDeleteBoardQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'idEnterprise' | 'idOrganization'>
    & { members: Array<(
      { __typename: 'Member' }
      & Pick<Types.Member, 'id'>
    )>, prefs?: Types.Maybe<(
      { __typename: 'Board_Prefs' }
      & Pick<Types.Board_Prefs, 'permissionLevel'>
    )> }
  )> }
);




/**
 * __useCanDeleteBoardQuery__
 *
 * To run a query within a React component, call `useCanDeleteBoardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanDeleteBoardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanDeleteBoardQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useCanDeleteBoardQuery(baseOptions: Apollo.QueryHookOptions<CanDeleteBoardQuery, CanDeleteBoardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CanDeleteBoardQuery, CanDeleteBoardQueryVariables>(CanDeleteBoardDocument, options);
      }
export function useCanDeleteBoardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanDeleteBoardQuery, CanDeleteBoardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CanDeleteBoardQuery, CanDeleteBoardQueryVariables>(CanDeleteBoardDocument, options);
        }
export type CanDeleteBoardQueryHookResult = ReturnType<typeof useCanDeleteBoardQuery>;
export type CanDeleteBoardLazyQueryHookResult = ReturnType<typeof useCanDeleteBoardLazyQuery>;
export type CanDeleteBoardQueryResult = Apollo.QueryResult<CanDeleteBoardQuery, CanDeleteBoardQueryVariables>;